import { useContext } from 'react';
import { AlertsContext } from 'providers/context';

export default function useAlerts(context = AlertsContext) {
  return useContext(context);
}
